import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ClientUserData } from "@/common/types/client/user.type";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useClientUsers } from "@/features/users/hooks/useClientUsers";
import DashboardFilterSheet from "../DashboardFilterSheet";

const DashboardFilterBuyerSheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: usersOptions,
  } = useClientUsers({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ClientUserData>({
      labelFieldName: 'full_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterSheet
      filterKey={DashboardFilters.Buyer}
      options={usersOptions}
      filters={filters}
      setFilters={setFilters}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterBuyerSheet;
